import Calendar from "@repo/icons/default/Calendar";
import CalendarFill from "@repo/icons/default/CalendarFill";
import Heart from "@repo/icons/default/Heart";
import HeartFill from "@repo/icons/default/HeartFill";
import Menu3 from "@repo/icons/default/Menu3";
import SofaV2 from "@repo/icons/default/SofaV2";
import SofaV2Fill from "@repo/icons/default/SofaV2Fill";
import UsersFill from "@repo/icons/default/UsersFill";
import UsersV3 from "@repo/icons/default/UsersV3";
import { type LinkProps, useSearch } from "@tanstack/react-router";

export interface NavItemProps {
  url: LinkProps["to"];
  search?: LinkProps["search"];
  Icon: React.ElementType;
  SelectedIcon: React.ElementType;
  title: string;
  /** Desligue (`false`) quando o `beforeLoad`/`loader` da rota tem efeito colateral. */
  preload?: LinkProps["preload"];
}

interface SearchParams {
  date?: string;
  locationId?: number;
}

export const useNavItems = (): Record<string, NavItemProps> => {
  const searchParams: SearchParams = useSearch({ strict: false });

  return {
    home: {
      Icon: Heart,
      SelectedIcon: HeartFill,
      url: "/home",
      title: "Para você",
    },
    calendar: {
      Icon: Calendar,
      SelectedIcon: CalendarFill,
      url: "/calendar",
      title: "Agenda",
      search: { date: searchParams.date, locationId: searchParams.locationId },
    },
    waitingRoom: {
      Icon: SofaV2,
      SelectedIcon: SofaV2Fill,
      url: "/waiting-room",
      title: "Espera",
    },
    patient: {
      Icon: UsersV3,
      SelectedIcon: UsersFill,
      url: "/patients",
      title: "Pacientes",
    },
    menu: {
      Icon: Menu3,
      SelectedIcon: Menu3,
      url: "/settings",
      title: "Menu",
    },
  };
};
